import React from "react";
import InvalidGraph from "../graphs/InvalidGraph";

interface GraphErrorBoundaryProps {
  children: React.ReactNode;
}

interface GraphErrorBoundaryState {
  hasError: boolean;
}

export class GraphErrorBoundary extends React.Component<
  GraphErrorBoundaryProps,
  GraphErrorBoundaryState
> {
  state: GraphErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(_: Error): GraphErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Graph render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <InvalidGraph />;
    }

    return this.props.children;
  }
}
